// src/constants/app.ts
/**
 * Application-wide constants
 */

// Time values in milliseconds
export const TIME = {
  MILLISECOND: 1,
  SECOND: 1000,
  MINUTE: 60 * 1000,
  HOUR: 60 * 60 * 1000,
  DAY: 24 * 60 * 60 * 1000,
};

// React Query configuration
export const QUERY = {
  STALE_TIME: TIME.HOUR, // Data considered fresh for 1 hour
  GC_TIME: TIME.DAY, // Keep unused data in cache for 1 day (garbage collection time)
  RETRY_COUNT: 3, // Number of retry attempts on failure
  RETRY_DELAY: (attempt: number) => Math.min(1000 * 2 ** attempt, 30000), // Exponential backoff
  REFETCH_ON_WINDOW_FOCUS: true, // Refetch when window gains focus
  REFETCH_INTERVAL: TIME.MINUTE * 5, // Auto-refetch every 5 minutes
} as const;

// Add other constant categories as needed
// export const API = { ... }
// export const UI = { ... }
// etc.
